<template>
  <div class="time-counter">
    {{ counter }}
  </div>
</template>

<script>
export default {
  props: ['timelineDurationSeconds', 'timelineProgressSeconds'],
  computed: {
    counter() {
      return this.timelineDurationSeconds - this.timelineProgressSeconds
    },
  },
}
</script>

<style scoped lang="scss">
.time-counter {
  font-family: AmsiProCondensed-Black;
  width: 114px;
  height: 114px;
  background-color: #ffcc4e;
  text-align: center;
  font-size: 80px;
  line-height: 80px;
  border-radius: 50%;
  color: #dd131c;
  padding: 18px 0 16px;
}
</style>
